import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

export const AvisoDePrivacidadAvanzaSolido = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));

  const font_title = isMobileOrTablet ? 20 : 28;
  const font_text = isMobileOrTablet ? 14 : 18;
  return (
    <>
      <Box mx={isMobileOrTablet ? 4 : 25} my={6}>
        <Typography color={theme?.palette?.primary?.main} textAlign={"center"} fontWeight={700} fontSize={font_title}>
          Aviso de Privacidad Avanza Sólido
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={2}
        >
          AVANZA SÓLIDO, S.A. DE C.V. SOFOM, ENR (En lo sucesivo AVANZA SÓLIDO)
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={2}
        >
          Av. El Ocote No. 405 Mz 5 Lt 3, Fracc. Las Nubes, C.P. 29087
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_text}
          mt={2}
        >
          Tuxtla Gutiérrez, Chiapas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          A todos nuestros solicitantes de crédito y Clientes (En lo sucesivo “Clientes”):
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          AVANZA SÓLIDO responsable del uso y protección de sus datos personales da a conocer a usted el presente Aviso
          de Privacidad, en cumplimiento a lo establecido por la Ley Federal de Protección de Datos Personales en
          Posesión de los Particulares (En lo sucesivo “Ley”).
        </Typography>

        <Typography
          color={theme?.palette?.primary?.main}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          DATOS PERSONALES TRATADOS Y FINALIDAD DEL TRATAMIENTO DE DATOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          AVANZA SÓLIDO recaba datos personales de sus solicitantes de crédito y Clientes de manera personal, a través
          de medios electrónicos, o por cualquier otro medio permitido por la “Ley” con la finalidad de identificar a
          sus Solicitantes y/o Clientes, para poder, en su caso, celebrar un contrato de crédito, informarles sobre el
          estatus del mismo, realizar requerimientos de pago, otorgarles información relacionada con los Contratos
          celebrados, contactarlos con la finalidad de mantener actualizados sus datos personales, mientras se encuentre
          vigente la relación jurídica entre el Cliente y AVANZA SOLIDO, en caso de que sea necesario actualizar algún
          dato personal, ceder o vender la cartera de créditos, así como ofrecerles los diferentes productos y/o
          servicios que tenemos a su disposición, para lo cual utilizaremos datos personales que AVANZA SOLIDO ha
          clasificado como sensibles como lo son datos de identificación, contacto, laborales, académicos, patrimoniales
          o financieros, de salud y de origen étnico o racial, por lo que AVANZA SOLIDO se compromete a reforzar las
          medidas de seguridad que garanticen en todo momento su confidencialidad y para lo cual es preciso contar con
          su consentimiento expreso en donde acepte o no el tratamiento de dichos datos.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Acepto el tratamiento de los datos considerados como sensibles descritos con anterioridad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Del mismo modo, de los Solicitantes y/o Clientes que manifiesten su consentimiento de manera expresa, AVANZA
          SÓLIDO, podrá hacer uso de imagen personal, mediante fotografías o videograbaciones expuestas al público en
          general con la finalidad de prospección comercial, así como de propaganda, y en general para cual fin
          publicitario.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Acepto el tratamiento de mis datos personales, aún de los considerados como sensibles con la finalidad de
          prospección comercial, propaganda y publicidad
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Como parte de las medidas de seguridad que AVANZA SOLIDO implementa en cada una de sus sucursales, tomará
          videograbación, con o sin sonido, las 24 horas del día. Las imágenes y/o sonidos que en su caso sean captados
          por las cámaras de video vigilancia serán utilizados para el resguardo de la seguridad de los Clientes y de
          las personas que laboran en las sucursales.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          A través del presente Aviso de Privacidad, AVANZA SOLIDO, garantiza el derecho de sus Clientes para manifestar
          su negativa para el tratamiento de sus datos personales con relación a las finalidades antes enunciadas y
          aquellas que el solicitante de crédito y el Cliente considere que no son necesarias para la relación jurídica,
          para lo cual el solicitante del crédito o Cliente deberá informar a AVANZA SOLIDO sobre su negativa al momento
          en que AVANZA SOLIDO le ponga a su disposición el presente Aviso de Privacidad, entendiéndose que el
          consentimiento expreso que el solicitante del crédito y el Cliente otorga al momento en que se le entrega el
          presente Aviso de Privacidad es señal de su conformidad, sin perjuicio de su derecho para revocar el
          consentimiento que previamente hubiere otorgado o bien para ejercer su derecho a oponerse al tratamiento de
          sus datos en términos de las disposiciones aplicables, derechos que en todo caso serán garantizados por AVANZA
          SOLIDO.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          TRANSFERENCIA DE DATOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          AVANZA SOLIDO utiliza los datos personales de sus Clientes exclusivamente para los fines señalados en el
          presente Aviso de Privacidad y los conserva por el tiempo que las disposiciones legales señalan. AVANZA SOLIDO
          comparte y/o transfiere los datos personales de sus solicitantes de crédito y Clientes a terceras personas en
          los casos señalados en el presente Aviso de Privacidad y en el contrato de crédito que en su caso se
          formalice, con sus fondeadores, así como cualquier entidad pública o privada, nacional o internacional, que
          haya intervenido en el financiamiento del crédito y/o otorgado cualquier tipo de apoyo, así como a las
          autoridades competentes que llegaran a requerirlo, con terceros cuando el Cliente contrata otro producto y/o
          servicio a través de AVANZA SOLIDO, cuando se cede o se vende la cartera de créditos, para hacer
          requerimientos de pago a través de despachos de cobranza y cuando así se requiera por disposición legal o por
          orden de autoridad competente debidamente fundada y motivada y en los supuestos señalados en el artículo 37 de
          la “Ley”. Fuera de los casos enunciados, nuestros Clientes tienen la confianza de que sus datos no serán
          transferidos a terceras personas sin su consentimiento.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          El Cliente manifiesta su conformidad para que AVANZA SOLIDO pueda llevar a cabo las transferencias en los
          supuestos previstos en el presente Aviso de Privacidad, a los terceros receptores antes mencionados y por las
          finalidades enunciadas, por lo que el Cliente manifiesta su consentimiento expreso al momento en que se le
          entrega y firma el presente Aviso de Privacidad.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Acepto las transferencias antes enunciadas.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          EJERCICIO DE LOS DERECHOS ARCO Y REVOCACION DEL CONSENTIMIENTO
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nuestros Clientes podrán ejercer en todo momento sus derechos ARCO. Tienen derecho a conocer que datos
          personales tenemos, para que los utilizamos y las condiciones de uso que les damos (Acceso), a solicitar la
          corrección de su información personal en caso de que este desactualizada, sea inexacta o incompleta
          (Rectificación), así mismo, tienen derecho a que la eliminemos de nuestros registros o bases de datos cuando
          considere que la misma no está siendo utilizada conforme a los principios, deberes y obligaciones previstas en
          la normativa (Cancelación); así como oponerse al uso de sus datos personales para fines específicos
          (Oposición), en caso de que legalmente sea procedente, conforme a los lineamientos y requisitos que marca la
          Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nuestros clientes pueden revocar el consentimiento que, en su caso, nos hayan otorgado para el tratamiento de
          sus datos personales. Sin embargo, es importante que tengan en cuenta que no en todos los casos podremos
          atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal
          requiramos seguir tratando sus datos personales. Así mismo, deberán considerar que para ciertos fines la
          revocación de su consentimiento implicara que no podamos seguir prestando el servicio que nos solicitó, o la
          conclusión de su relación con nosotros. Ley.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          MEDIOS Y PROCEDIMIENTO PARA EL EJERCICIO DE LOS DERECHOS ARCO Y REVOCACION DEL CONSENTIMIENTO.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nuestros Clientes podrán ejercer sus derechos ARCO y revocar su consentimiento para el tratamiento de sus
          datos personales, a través de la solicitud respectiva, que podrá ser obtenida en forma gratuita en la sucursal
          que le corresponda, en atención al área jurídica, y en donde se le indicaran los requisitos y el procedimiento
          a seguir para cualquiera de los dos supuestos, o bien, usted podrá llamar al siguiente número telefónico:
          (961) 612 10 24 en donde se atenderá cualquier duda que pudiera tener al respecto.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          LIMITANTES DEL USO O DIVULGACIÓN DE LOS DATOS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Nuestros Clientes podrán limitar el uso o divulgación de sus datos personales inscribiéndose en el Registro
          Público de Usuarios de Servicios Financieros o solicitando a AVANZA SOLIDO registre sus datos personales en
          los listados de exclusión dentro del término de veinte días naturales contados a partir de la presentación de
          la solicitud respectiva que podrá ser obtenida en forma gratuita en la sucursal que le corresponda, en
          atención al área jurídica, y en donde se le indicaran los requisitos y el procedimiento a seguir, o bien,
          usted podrá llamar al siguiente número telefónico: (961) 612 10 24 en donde se atenderá cualquier duda que
          pudiera tener al respecto.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          USO DE COOKIES Y WEB BEACONS
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          AVANZA SOLIDO utiliza varias tecnologías para mejorar la eficiencia de su sitio web www.avanzasolido.com.mx
          Entre estas tecnologías se incluye en uso de cookies (pequeñas cantidades de información que se almacenan en
          el navegador utilizado por cada usuario para que el servidor recuerde cierta información que posteriormente se
          pueda utilizar) y web bancos (imagen visible u oculta insertada dentro de un sitio web o correo electrónico,
          que se utiliza para monitorear el comportamiento del usuario en estos medios, así como almacenar información
          sobre la dirección IP del usuario, duración del tiempo de interacción en dicha página, el tipo de navegador
          utilizado, entre otros). Los Clientes pueden, en todo momento, deshabilitar el uso de este tipo de tecnologías
          en sus equipos de cómputo.
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={700}
          fontSize={font_title}
          mt={4}
        >
          COMUNICACIÓN
        </Typography>

        <Typography
          color={theme?.palette?.primary?.dark}
          textAlign={"justify"}
          fontWeight={400}
          fontSize={font_text}
          mt={4}
        >
          Cualquier cambio y/o modificación total o parcial al presente Aviso de Privacidad se dará a conocer a nuestros
          Clientes directamente en las sucursales de nuestra empresa y/o mediante la publicación del mismo en la
          siguiente página web:{" "}
          <a href=" https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf" target="_blank">
            https://www.avanzasolido.com.mx/files/avisodeprivacidadASO.pdf
          </a>
          <br /><br />
        </Typography>
      </Box>
    </>
  );
};
